<template>
  <div class="order-dialog">
    <el-dialog
      :title="titleName"
      :visible="value"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="resetForm"
      :width="width"
    >
    <slot name="content"></slot>
    <slot name="footer"></slot>
    <!--公用弹框--->
    <div v-if="iSPublicDialog">
      <template>
        {{TipContent}}
      </template>
      <div class="btn mt15 flex flex-space-end">
          <div class="cancelBtn cursor" @click="resetForm">取消</div>
          <div class="lineBlueBtnW cursor" @click="resetForm">确定</div>
      </div>
    </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      require: false,
      default: false,
    },
    width:{
      type:String,
      default:"600px"
    },
    height:{
      type:String,
      default:"200px"
    },
    //弹框标题内容
    titleName:{
      type:String,
      default:'信息'
    },
    //弹框内容信息
    TipContent:{
      type:String,
      default:'',
    },
    //公用提示弹框
    iSPublicDialog:{
      type:Boolean,
      default:false,
    }

  },
  components: {

  },
  data() {
    return {

    };
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  mounted() {

  },
  methods: {
    resetForm() {
      this.$emit('input', false);
    },
    submitForm() {
      this.$emit('reCheckPrice', true);
      this.resetForm();
    }
  },
};
</script>
<style scoped lang="scss">
::v-deep{
  .el-dialog{
      background: #FFFFFF;
      box-shadow: 0px 0px 11px 0px rgba(0,0,0,0.25);
      border-radius: 10px;
  }
} 

</style>
